// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/signal_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AnalysisQuote } from "../../controls/v1/analysis_result_pb";
import { file_controls_v1_analysis_result } from "../../controls/v1/analysis_result_pb";
import type { AlertTimelineItem } from "./alert_pb";
import { file_inventory_v1_alert } from "./alert_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Signal, SignalType } from "./signal_pb";
import { file_inventory_v1_signal } from "./signal_pb";
import type { BackofficeSignal } from "./signal_backoffice_pb";
import { file_inventory_v1_signal_backoffice } from "./signal_backoffice_pb";
import type { SignalDetail, SignalMitigationGroup } from "./signal_detail_pb";
import { file_inventory_v1_signal_detail } from "./signal_detail_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/signal_service.proto.
 */
export const file_inventory_v1_signal_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_controls_v1_analysis_result, file_inventory_v1_alert, file_inventory_v1_risk, file_inventory_v1_signal, file_inventory_v1_signal_backoffice, file_inventory_v1_signal_detail]);

/**
 * @generated from message inventory.v1.ListSignalsRequest
 */
export type ListSignalsRequest = Message<"inventory.v1.ListSignalsRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;
};

/**
 * Describes the message inventory.v1.ListSignalsRequest.
 * Use `create(ListSignalsRequestSchema)` to create a new message.
 */
export const ListSignalsRequestSchema: GenMessage<ListSignalsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 0);

/**
 * @generated from message inventory.v1.ListSignalsResponse
 */
export type ListSignalsResponse = Message<"inventory.v1.ListSignalsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Signal signals = 1;
   */
  signals: Signal[];
};

/**
 * Describes the message inventory.v1.ListSignalsResponse.
 * Use `create(ListSignalsResponseSchema)` to create a new message.
 */
export const ListSignalsResponseSchema: GenMessage<ListSignalsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 1);

/**
 * @generated from message inventory.v1.ListSignalsIncludingInvisibleRequest
 */
export type ListSignalsIncludingInvisibleRequest = Message<"inventory.v1.ListSignalsIncludingInvisibleRequest"> & {
  /**
   * @generated from field: optional string company_id = 1;
   */
  companyId?: string;
};

/**
 * Describes the message inventory.v1.ListSignalsIncludingInvisibleRequest.
 * Use `create(ListSignalsIncludingInvisibleRequestSchema)` to create a new message.
 */
export const ListSignalsIncludingInvisibleRequestSchema: GenMessage<ListSignalsIncludingInvisibleRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 2);

/**
 * @generated from message inventory.v1.ListSignalsIncludingInvisibleResponse
 */
export type ListSignalsIncludingInvisibleResponse = Message<"inventory.v1.ListSignalsIncludingInvisibleResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Signal signals = 1;
   */
  signals: Signal[];
};

/**
 * Describes the message inventory.v1.ListSignalsIncludingInvisibleResponse.
 * Use `create(ListSignalsIncludingInvisibleResponseSchema)` to create a new message.
 */
export const ListSignalsIncludingInvisibleResponseSchema: GenMessage<ListSignalsIncludingInvisibleResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 3);

/**
 * @generated from message inventory.v1.GetSignalRequest
 */
export type GetSignalRequest = Message<"inventory.v1.GetSignalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional bool static_output = 2;
   */
  staticOutput?: boolean;
};

/**
 * Describes the message inventory.v1.GetSignalRequest.
 * Use `create(GetSignalRequestSchema)` to create a new message.
 */
export const GetSignalRequestSchema: GenMessage<GetSignalRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 4);

/**
 * @generated from message inventory.v1.GetSignalResponse
 */
export type GetSignalResponse = Message<"inventory.v1.GetSignalResponse"> & {
  /**
   * @generated from field: inventory.v1.Signal signal = 1;
   */
  signal?: Signal;

  /**
   * @generated from field: inventory.v1.SignalDetail detail = 2;
   */
  detail?: SignalDetail;
};

/**
 * Describes the message inventory.v1.GetSignalResponse.
 * Use `create(GetSignalResponseSchema)` to create a new message.
 */
export const GetSignalResponseSchema: GenMessage<GetSignalResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 5);

/**
 * @generated from message inventory.v1.GetSignalTimelineRequest
 */
export type GetSignalTimelineRequest = Message<"inventory.v1.GetSignalTimelineRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.GetSignalTimelineRequest.
 * Use `create(GetSignalTimelineRequestSchema)` to create a new message.
 */
export const GetSignalTimelineRequestSchema: GenMessage<GetSignalTimelineRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 6);

/**
 * @generated from message inventory.v1.GetSignalTimelineResponse
 */
export type GetSignalTimelineResponse = Message<"inventory.v1.GetSignalTimelineResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AlertTimelineItem items = 1;
   */
  items: AlertTimelineItem[];
};

/**
 * Describes the message inventory.v1.GetSignalTimelineResponse.
 * Use `create(GetSignalTimelineResponseSchema)` to create a new message.
 */
export const GetSignalTimelineResponseSchema: GenMessage<GetSignalTimelineResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 7);

/**
 * @generated from message inventory.v1.MarkSignalFalsePositiveRequest
 */
export type MarkSignalFalsePositiveRequest = Message<"inventory.v1.MarkSignalFalsePositiveRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool is_false_positive = 2;
   */
  isFalsePositive: boolean;

  /**
   * @generated from field: optional string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message inventory.v1.MarkSignalFalsePositiveRequest.
 * Use `create(MarkSignalFalsePositiveRequestSchema)` to create a new message.
 */
export const MarkSignalFalsePositiveRequestSchema: GenMessage<MarkSignalFalsePositiveRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 8);

/**
 * @generated from message inventory.v1.MarkSignalFalsePositiveResponse
 */
export type MarkSignalFalsePositiveResponse = Message<"inventory.v1.MarkSignalFalsePositiveResponse"> & {
};

/**
 * Describes the message inventory.v1.MarkSignalFalsePositiveResponse.
 * Use `create(MarkSignalFalsePositiveResponseSchema)` to create a new message.
 */
export const MarkSignalFalsePositiveResponseSchema: GenMessage<MarkSignalFalsePositiveResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 9);

/**
 * @generated from message inventory.v1.AddSignalCommentRequest
 */
export type AddSignalCommentRequest = Message<"inventory.v1.AddSignalCommentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;
};

/**
 * Describes the message inventory.v1.AddSignalCommentRequest.
 * Use `create(AddSignalCommentRequestSchema)` to create a new message.
 */
export const AddSignalCommentRequestSchema: GenMessage<AddSignalCommentRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 10);

/**
 * @generated from message inventory.v1.AddSignalCommentResponse
 */
export type AddSignalCommentResponse = Message<"inventory.v1.AddSignalCommentResponse"> & {
};

/**
 * Describes the message inventory.v1.AddSignalCommentResponse.
 * Use `create(AddSignalCommentResponseSchema)` to create a new message.
 */
export const AddSignalCommentResponseSchema: GenMessage<AddSignalCommentResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 11);

/**
 * @generated from message inventory.v1.CreateOrgSignalRequest
 */
export type CreateOrgSignalRequest = Message<"inventory.v1.CreateOrgSignalRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string subtitle = 3;
   */
  subtitle?: string;

  /**
   * @generated from field: optional bool visible = 4;
   */
  visible?: boolean;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: optional string risk_description = 6;
   */
  riskDescription?: string;

  /**
   * @generated from field: inventory.v1.SignalType signal_type = 11;
   */
  signalType: SignalType;

  /**
   * @generated from field: repeated controls.v1.AnalysisQuote quotes = 12;
   */
  quotes: AnalysisQuote[];

  /**
   * @generated from field: repeated inventory.v1.SignalMitigationGroup mitigation_groups = 13;
   */
  mitigationGroups: SignalMitigationGroup[];

  /**
   * Makes the signal an alert without a matching alert rule.
   *
   * @generated from field: bool bypass_alert_rules = 14;
   */
  bypassAlertRules: boolean;

  /**
   * Stored as the manual severity, so it wins over the signal type's default level.
   *
   * @generated from field: optional inventory.v1.RiskLevel severity = 15;
   */
  severity?: RiskLevel;
};

/**
 * Describes the message inventory.v1.CreateOrgSignalRequest.
 * Use `create(CreateOrgSignalRequestSchema)` to create a new message.
 */
export const CreateOrgSignalRequestSchema: GenMessage<CreateOrgSignalRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 12);

/**
 * @generated from message inventory.v1.CreateOrgSignalResponse
 */
export type CreateOrgSignalResponse = Message<"inventory.v1.CreateOrgSignalResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateOrgSignalResponse.
 * Use `create(CreateOrgSignalResponseSchema)` to create a new message.
 */
export const CreateOrgSignalResponseSchema: GenMessage<CreateOrgSignalResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 13);

/**
 * @generated from message inventory.v1.CreateSignalRequest
 */
export type CreateSignalRequest = Message<"inventory.v1.CreateSignalRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string subtitle = 3;
   */
  subtitle?: string;

  /**
   * @generated from field: optional inventory.v1.RiskLevel level = 4;
   */
  level?: RiskLevel;

  /**
   * @generated from field: optional bool visible = 5;
   */
  visible?: boolean;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * @generated from field: optional string risk_description = 7;
   */
  riskDescription?: string;

  /**
   * @generated from field: inventory.v1.SignalType signal_type = 11;
   */
  signalType: SignalType;

  /**
   * A company-scoped signal can't cite an org document.
   *
   * @generated from field: repeated controls.v1.AnalysisQuote quotes = 12;
   */
  quotes: AnalysisQuote[];

  /**
   * @generated from field: repeated inventory.v1.SignalMitigationGroup mitigation_groups = 13;
   */
  mitigationGroups: SignalMitigationGroup[];

  /**
   * Global company id, used instead of company_id (an org company id) so no org has to track the vendor.
   *
   * @generated from field: optional string global_company_id = 16;
   */
  globalCompanyId?: string;
};

/**
 * Describes the message inventory.v1.CreateSignalRequest.
 * Use `create(CreateSignalRequestSchema)` to create a new message.
 */
export const CreateSignalRequestSchema: GenMessage<CreateSignalRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 14);

/**
 * @generated from message inventory.v1.CreateSignalResponse
 */
export type CreateSignalResponse = Message<"inventory.v1.CreateSignalResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateSignalResponse.
 * Use `create(CreateSignalResponseSchema)` to create a new message.
 */
export const CreateSignalResponseSchema: GenMessage<CreateSignalResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 15);

/**
 * @generated from message inventory.v1.SetOrgSignalVisibilityRequest
 */
export type SetOrgSignalVisibilityRequest = Message<"inventory.v1.SetOrgSignalVisibilityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool visible = 2;
   */
  visible: boolean;
};

/**
 * Describes the message inventory.v1.SetOrgSignalVisibilityRequest.
 * Use `create(SetOrgSignalVisibilityRequestSchema)` to create a new message.
 */
export const SetOrgSignalVisibilityRequestSchema: GenMessage<SetOrgSignalVisibilityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 16);

/**
 * @generated from message inventory.v1.SetOrgSignalVisibilityResponse
 */
export type SetOrgSignalVisibilityResponse = Message<"inventory.v1.SetOrgSignalVisibilityResponse"> & {
};

/**
 * Describes the message inventory.v1.SetOrgSignalVisibilityResponse.
 * Use `create(SetOrgSignalVisibilityResponseSchema)` to create a new message.
 */
export const SetOrgSignalVisibilityResponseSchema: GenMessage<SetOrgSignalVisibilityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 17);

/**
 * @generated from message inventory.v1.SetOrgSignalFalsePositiveRequest
 */
export type SetOrgSignalFalsePositiveRequest = Message<"inventory.v1.SetOrgSignalFalsePositiveRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool is_false_positive = 2;
   */
  isFalsePositive: boolean;

  /**
   * Ignored when clearing.
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message inventory.v1.SetOrgSignalFalsePositiveRequest.
 * Use `create(SetOrgSignalFalsePositiveRequestSchema)` to create a new message.
 */
export const SetOrgSignalFalsePositiveRequestSchema: GenMessage<SetOrgSignalFalsePositiveRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 18);

/**
 * @generated from message inventory.v1.SetOrgSignalFalsePositiveResponse
 */
export type SetOrgSignalFalsePositiveResponse = Message<"inventory.v1.SetOrgSignalFalsePositiveResponse"> & {
};

/**
 * Describes the message inventory.v1.SetOrgSignalFalsePositiveResponse.
 * Use `create(SetOrgSignalFalsePositiveResponseSchema)` to create a new message.
 */
export const SetOrgSignalFalsePositiveResponseSchema: GenMessage<SetOrgSignalFalsePositiveResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 19);

/**
 * @generated from message inventory.v1.ListSignalsBackofficeRequest
 */
export type ListSignalsBackofficeRequest = Message<"inventory.v1.ListSignalsBackofficeRequest"> & {
};

/**
 * Describes the message inventory.v1.ListSignalsBackofficeRequest.
 * Use `create(ListSignalsBackofficeRequestSchema)` to create a new message.
 */
export const ListSignalsBackofficeRequestSchema: GenMessage<ListSignalsBackofficeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 20);

/**
 * @generated from message inventory.v1.ListSignalsBackofficeResponse
 */
export type ListSignalsBackofficeResponse = Message<"inventory.v1.ListSignalsBackofficeResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.BackofficeSignal signals = 1;
   */
  signals: BackofficeSignal[];
};

/**
 * Describes the message inventory.v1.ListSignalsBackofficeResponse.
 * Use `create(ListSignalsBackofficeResponseSchema)` to create a new message.
 */
export const ListSignalsBackofficeResponseSchema: GenMessage<ListSignalsBackofficeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 21);

/**
 * @generated from message inventory.v1.GetSignalBackofficeRequest
 */
export type GetSignalBackofficeRequest = Message<"inventory.v1.GetSignalBackofficeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.GetSignalBackofficeRequest.
 * Use `create(GetSignalBackofficeRequestSchema)` to create a new message.
 */
export const GetSignalBackofficeRequestSchema: GenMessage<GetSignalBackofficeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 22);

/**
 * @generated from message inventory.v1.GetSignalBackofficeResponse
 */
export type GetSignalBackofficeResponse = Message<"inventory.v1.GetSignalBackofficeResponse"> & {
  /**
   * @generated from field: inventory.v1.BackofficeSignal signal = 1;
   */
  signal?: BackofficeSignal;

  /**
   * @generated from field: inventory.v1.SignalDetail detail = 2;
   */
  detail?: SignalDetail;

  /**
   * @generated from field: repeated inventory.v1.AlertTimelineItem timeline = 3;
   */
  timeline: AlertTimelineItem[];
};

/**
 * Describes the message inventory.v1.GetSignalBackofficeResponse.
 * Use `create(GetSignalBackofficeResponseSchema)` to create a new message.
 */
export const GetSignalBackofficeResponseSchema: GenMessage<GetSignalBackofficeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_service, 23);

/**
 * SignalService exposes read access to signals (the unfiltered feed of every
 * collected event, regardless of whether any rule promoted them to alerts)
 * plus the per-signal user-input mutations (false-positive marks, comment
 * threads). Both the signal-feed view and the alert-detail view call into
 * these mutations because the underlying entity is the same.
 *
 * Two write RPCs are kept here for the support workflow: CreateSignal and
 * CreateOrgSignal let the support team manually inject signals during
 * incidents. Both are admin / support-user gated.
 *
 * @generated from service inventory.v1.SignalService
 */
export const SignalService: GenService<{
  /**
   * @generated from rpc inventory.v1.SignalService.ListSignals
   */
  listSignals: {
    methodKind: "unary";
    input: typeof ListSignalsRequestSchema;
    output: typeof ListSignalsResponseSchema;
  },
  /**
   * Support-only. Includes hidden + false-positive rows. Hidden titles arrive
   * with a "* " prefix.
   *
   * @generated from rpc inventory.v1.SignalService.ListSignalsIncludingInvisible
   */
  listSignalsIncludingInvisible: {
    methodKind: "unary";
    input: typeof ListSignalsIncludingInvisibleRequestSchema;
    output: typeof ListSignalsIncludingInvisibleResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.SignalService.GetSignal
   */
  getSignal: {
    methodKind: "unary";
    input: typeof GetSignalRequestSchema;
    output: typeof GetSignalResponseSchema;
  },
  /**
   * Returns the alert-lifecycle timeline for the alert promoted from this
   * signal: status transitions, severity changes, comments. Both the alert
   * detail view and the signal detail view call this — same backing data.
   *
   * @generated from rpc inventory.v1.SignalService.GetSignalTimeline
   */
  getSignalTimeline: {
    methodKind: "unary";
    input: typeof GetSignalTimelineRequestSchema;
    output: typeof GetSignalTimelineResponseSchema;
  },
  /**
   * Toggle the false-positive flag on a signal. False-positive signals don't
   * surface as alerts (alert_visible flips to false). Used from both the
   * signal feed view and the alert detail view.
   *
   * @generated from rpc inventory.v1.SignalService.MarkSignalFalsePositive
   */
  markSignalFalsePositive: {
    methodKind: "unary";
    input: typeof MarkSignalFalsePositiveRequestSchema;
    output: typeof MarkSignalFalsePositiveResponseSchema;
  },
  /**
   * Add a comment to the signal's comment thread. The thread is shared with
   * the signal's promoted-alert view (one thread per signal).
   *
   * @generated from rpc inventory.v1.SignalService.AddSignalComment
   */
  addSignalComment: {
    methodKind: "unary";
    input: typeof AddSignalCommentRequestSchema;
    output: typeof AddSignalCommentResponseSchema;
  },
  /**
   * Support-only: set org signal visibility (hide/unhide).
   *
   * @generated from rpc inventory.v1.SignalService.SetOrgSignalVisibility
   */
  setOrgSignalVisibility: {
    methodKind: "unary";
    input: typeof SetOrgSignalVisibilityRequestSchema;
    output: typeof SetOrgSignalVisibilityResponseSchema;
  },
  /**
   * Support-only: set or clear a signal's false positive, both directions.
   *
   * @generated from rpc inventory.v1.SignalService.SetOrgSignalFalsePositive
   */
  setOrgSignalFalsePositive: {
    methodKind: "unary";
    input: typeof SetOrgSignalFalsePositiveRequestSchema;
    output: typeof SetOrgSignalFalsePositiveResponseSchema;
  },
  /**
   * Support-only: every signal of the org, hidden and false positives included.
   *
   * @generated from rpc inventory.v1.SignalService.ListSignalsBackoffice
   */
  listSignalsBackoffice: {
    methodKind: "unary";
    input: typeof ListSignalsBackofficeRequestSchema;
    output: typeof ListSignalsBackofficeResponseSchema;
  },
  /**
   * Support-only: one signal with its detail and full timeline, support rows included.
   *
   * @generated from rpc inventory.v1.SignalService.GetSignalBackoffice
   */
  getSignalBackoffice: {
    methodKind: "unary";
    input: typeof GetSignalBackofficeRequestSchema;
    output: typeof GetSignalBackofficeResponseSchema;
  },
  /**
   * Support-only: create an org-scoped signal with optional document quotes.
   * The "Org" prefix here is intentional and disambiguates from CreateSignal
   * (which creates a company-level signal); both stay support-only.
   *
   * @generated from rpc inventory.v1.SignalService.CreateOrgSignal
   */
  createOrgSignal: {
    methodKind: "unary";
    input: typeof CreateOrgSignalRequestSchema;
    output: typeof CreateOrgSignalResponseSchema;
  },
  /**
   * Support-only: create a company-scoped signal (EU-hosted only).
   *
   * @generated from rpc inventory.v1.SignalService.CreateSignal
   */
  createSignal: {
    methodKind: "unary";
    input: typeof CreateSignalRequestSchema;
    output: typeof CreateSignalResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_signal_service, 0);

